export default "__VITE_PUBLIC_ASSET__e241b74c__"